import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { PORTAL_SIDEBAR_WIDTH } from '../../styles/portalTheme';

export const SIDEBAR_WIDTH = PORTAL_SIDEBAR_WIDTH;

/** Permanent sidebar from this breakpoint up; drawer below (phones + tablets). */
export const SIDEBAR_DESKTOP_BREAKPOINT = 'lg';

/**
 * Permanent sidebar from lg up; temporary drawer below lg (phones and tablets).
 */
const ResponsiveSidebar = ({ children, mobileOpen, onMobileClose }) => {
  const theme = useTheme();
  const portal = theme.portal;
  const isDesktop = useMediaQuery(theme.breakpoints.up(SIDEBAR_DESKTOP_BREAKPOINT));
  const location = useLocation();

  const drawerPaperSx = {
    width: SIDEBAR_WIDTH,
    boxSizing: 'border-box',
    borderRight: `1px solid ${portal.border}`,
    bgcolor: portal.sidebarBg,
  };

  useEffect(() => {
    if (!isDesktop) {
      onMobileClose();
    }
  }, [location.pathname, isDesktop, onMobileClose]);

  const navPanel = (
    <Box
      component="nav"
      aria-label="Main navigation"
      sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        py: 3,
        height: '100%',
      }}
    >
      {children}
    </Box>
  );

  return (
    <>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', lg: 'none' },
          '& .MuiDrawer-paper': drawerPaperSx,
        }}
      >
        {navPanel}
      </Drawer>

      <Box
        sx={{
          width: SIDEBAR_WIDTH,
          flexShrink: 0,
          display: { xs: 'none', lg: 'flex' },
          flexDirection: 'column',
          overflow: 'hidden',
          borderRight: `1px solid ${portal.border}`,
          bgcolor: portal.sidebarBg,
        }}
      >
        {navPanel}
      </Box>
    </>
  );
};

export default ResponsiveSidebar;
